import React from 'react';
import { useWhatsappFloating } from '../../../Hooks/Whatsapp/WhatsappHook';

const WhatsAppFloating = () => {
    const { whatsappUrl, isAvailable } = useWhatsappFloating();

    if (!isAvailable) return null;

    return (
        <a 
            href={whatsappUrl} 
            target="_blank" 
            rel="noopener noreferrer" 
            style={{
                position: 'fixed',
                bottom: '30px',
                right: '30px',
                zIndex: '999999',
                width: '60px',
                height: '60px',
                backgroundColor: '#25d366',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                fontSize: '30px',
                boxShadow: '2px 2px 15px rgba(0,0,0,0.2)',
                textDecoration: 'none'
            }}
        >
            <i className="ri-whatsapp-line"></i>
        </a>
    );
};

export default WhatsAppFloating;